import { HttpClient } from 'api/http-client';
import { Meeting } from './types';

class MeetingClient extends HttpClient {
  public getMeetings = (): Promise<Meeting[]> =>
    this.get<Meeting[]>('/meeting');
}

export const MeetingAPI = new MeetingClient();
